export class WebUserDataConstants {
	public static readonly TAXES: string = '/wds/api/security-taxes';
	public static readonly SECURITY_DATA: string = '/wds/json/security-data';
	public static readonly PORTFOLIO_ANALYSIS: string = '/wds/services/portfolio-analysis';
	public static readonly MODEL_PORTFOLIOS_CONFIG = '/wds/api/config-file/bfa:model-portfolios';
	public static readonly MANAGED_MODELS_CONFIG = '/wds/api/config-file/bfa:managed-models?viewId=managed@partner';
	public static readonly AREAS_TO_EXPLORE_CONFIG = '/wds/api/config-file/bfa:config:areas-to-explore';
	public static readonly PC_OBSERVATIONS_CONFIG = '/wds/api/config-file/portfolio-centre:config:observations-pc';
	public static readonly PORTFOLIO_TAGGING_CONFIG = '/wds/api/config-file/bfa:config:portfolio-tags';
	public static readonly BFA_ASSET_CLASS_SECURITIES: string = '/wds/search/bfa-asset-class-securities';
	public static readonly PS_REPORT_CONFIG = ':config:ps-pdf-report';
	public static readonly ADVISOR_REPORT_CONFIG = ':config:advisor-pdf-report';
	public static readonly CLIENT_REPORT_CONFIG = ':config:client-pdf-report';
	public static readonly PROPOSAL_REPORT_CONFIG = ':config:proposal-pdf-report';
	public static readonly PROPOSAL_SNAPSHOT_REPORT_CONFIG = ':config:proposal-snapshot-pdf-report';
	public static readonly PDF_SVG_API = '/advisor-center/pdf/generateStream';
	public static readonly FUND_IDEAS = '/advisor-center/fund-ideas/';
	public static readonly MDS_SCENARIOS_CONFIG = '/wds/api/config-file/bfa:config:mds-scenarios';
	public static readonly GOALS_CONFIG = '/wds/api/config-file/bfa:config:goals';
	public static readonly STRATEGIES_CONFIG = '/wds/api/config-file/bfa:config:strategies';
	public static readonly STRATEGIES_RULES_ENGINE_CONFIG = '/wds/api/config-file/bfa:config:strategies-rules-engine';
	public static readonly THIRD_PARTY_MODELS_LIST = '/iretire-server/services/v1/model-families/third-party';
	public static readonly ALL_MODELS_LIST_V2 = '/iretire-server/services/v2/model-families';
	public static readonly CONFIGS = '/wds/api/config-file/';
	public static readonly EXCEL_GENERATE = '/advisor-center/excel/';
	public static readonly FEATURE_FLAG_CONFIG = '/wds/api/config-file/bfa:config:feature-flag';
	public static readonly CONFIG_LAYER_CONFIG = ':config:config-layer';
	public static readonly PORTFOLIO_MONITORING_RULES = '/wds/api/config-file/bfa:config:portfolio-monitoring?variants=rules';
	public static readonly PORTFOLIO_MONITORING_BENCHMARKS = '/wds/api/config-file/bfa:config:portfolio-monitoring?variants=benchmarks';
	public static readonly MODEL_PORTFOLIOS_BENCHMARK_MAPPER_CONFIG = '/wds/api/config-file/bfa:config:model-portfolios-benchmark-mapper';
	public static readonly MODEL_EVALUATOR_MARKET_VIEW = '/wds/api/config-file/bfa:mval:config:asset-view';
	public static readonly MODELS_EXPERIENCE_MARKET_VIEW = '/wds/api/config-file/bfa:me:config:asset-view';
	public static readonly MODELS_EXPERIENCE_BLK_SUPPRESSION = '/wds/api/config-file/bfa:config:me-suppression';


	public static readonly USER_DATA_URL_SHORT = {
		GET_ALL: 'get-all'
	};

	public static readonly USER_DATA_URL = {
		ADD: '/wds/partner-data/add',
		ADD_PORTFOLIO: '/wds/partner-data/add-portfolio',
		EDIT: '/wds/partner-data/edit',
		GET: '/wds/partner-data/get',
		SET: '/wds/partner-data/set',
		GET_ALL: '/wds/partner-data/get-all',
		GET_VERSIONS: '/wds/partner-data/get-versions',
		GET_PREFERENCE: '/wds/partner-data/get-preference',
		REMOVE: '/wds/partner-data/remove',
		SEARCH: '/wds/partner-data/search',
		PDF: '/wds/partner-data/get-pdf'
	};

	public static readonly ASSET_CLASSES = {
		EQUITY: 'Equity',
		FIXED_INCOME: 'Fixed Income',
		ALLOCATION: 'Multi Asset',
		ALTERNATIVE: 'Alternatives',
		OTHER: 'Other'
	};

	public static readonly IDENTIFIER_TYPE = {
		BCUSIP: 'BCUSIP',
		CUSIP: 'CUSIP',
		SECURITY_ID: 'SECURITY_ID',
		GLOBAL_ID: 'GLOBAL_ID',
		ALADDIN_ID: 'ALADDIN_ID',
		MORNINGSTAR_SEC_ID: 'MORNINGSTAR_SEC_ID',
		TICKER: 'TICKER',
		MODEL_ID: 'MODEL_ID',
		PORTFOLIO_ID: 'PORTFOLIO_ID',
		THIRD_PARTY_ID: 'THIRD_PARTY_ID',
		CUSTOM: 'CUSTOM'
	};

	public static readonly SECURITY_IDENTIFIERS = [
		WebUserDataConstants.IDENTIFIER_TYPE.GLOBAL_ID,
		WebUserDataConstants.IDENTIFIER_TYPE.BCUSIP,
		WebUserDataConstants.IDENTIFIER_TYPE.MORNINGSTAR_SEC_ID,
		WebUserDataConstants.IDENTIFIER_TYPE.SECURITY_ID,
		WebUserDataConstants.IDENTIFIER_TYPE.CUSIP
	];

	public static readonly IDENTIFIER_TO_IDENTIFIER_TYPE_MAPPING = {
		globalId: WebUserDataConstants.IDENTIFIER_TYPE.GLOBAL_ID,
		bcusip: WebUserDataConstants.IDENTIFIER_TYPE.BCUSIP,
		aladdinId: WebUserDataConstants.IDENTIFIER_TYPE.BCUSIP,
		assetId: WebUserDataConstants.IDENTIFIER_TYPE.BCUSIP,
		cusip: WebUserDataConstants.IDENTIFIER_TYPE.BCUSIP, // fallback for old WDS cash & customised model securities
		morningstarSecId: WebUserDataConstants.IDENTIFIER_TYPE.MORNINGSTAR_SEC_ID, // only to support old implementation of adding new security in emea
		securityId: WebUserDataConstants.IDENTIFIER_TYPE.SECURITY_ID // temporary for wds decom, this is to store in PE using SECURITY_ID
	};

	/** Use HoldingsUtil.retrieveImportantSecurityIdentifiers constant to copy important fields when cloning */
	public static readonly SECURITY_IMPORTANT_FIELDS = [
		...Object.keys(this.IDENTIFIER_TO_IDENTIFIER_TYPE_MAPPING),
		'assetType', 'isin', 'regionCode', 'ticker'
	];

	public static readonly US_NEW_SECURITY_IDENTIFIER_ORDER = ['globalId', 'assetId', 'morningstarSecId'];
	public static readonly EMEA_NEW_SECURITY_IDENTIFIER_ORDER = ['assetId', 'aladdinId', 'globalId', 'morningstarSecId'];

	public static readonly TOOL_SERVICE_URL = {
		GET_USER: '/wds/services/user/get-user',
		REPORT: '/wds/services/pdf/create',
		REPORT_MP: '/wds/services/pdf/create/portfolio-report'
	};

	public static readonly REPORT_TYPE = {
		// TODO libian: remove after bpas decom
		BPAS_EXCEL: 'portfolios-bpas-report-excel.rptdesign'
	};

	public static readonly USER_DATA_PERMS = {
		DELETE: ['webUserDataPerm@AdvisorPort'],
		EDIT: ['webUserDataPerm@AdvisorPort'],
		SHARE: ['webUserDataPerm@AdvisorPort'],
		VIEW: ['webUserDataPerm@AdvisorPort']
	};

	public static readonly ALLOWED_USER_DATA_PERM_TYPES = {
		SHARE: 'SHARE',
		TRANSFER: 'TRANSFER',
		DELETE: 'DELETE',
		EDIT: 'EDIT',
		VIEW: 'VIEW'
	};

	public static readonly SUBTYPE = {
		ASSET_CLASS: 'ASSET_CLASS',
		SAMPLE: 'SAMPLE',
		TAX_REPORT: 'TAX-REPORT',
		SAVED: 'SAVED',
		SUBSCRIBED: 'SUBSCRIBED',
		CLIENT_CURRENT: 'CLIENT_CURRENT',
		MODEL_CURRENT: 'MODEL_CURRENT',
		MODEL_PORTFOLIO: 'MODEL_PORTFOLIO',
		SMA_REQUEST: 'SMA_REQUEST',
		BENCHMARK: 'BENCHMARK',
		HYPOTHETICAL: 'HYPOTHETICAL',
		PARTNER_MODEL: 'THIRD_PARTY_MODEL', // DO NOT CHANGE VALUE OF PARTNER_MODEL AS THIS IS THE VALUE THAT COMES FROM WTP
		PROSPECT_PORTFOLIO: 'PROSPECT_PORTFOLIO',
		EXTERNAL_PORTFOLIO: 'EXTERNAL_PORTFOLIO'
	};

	public static readonly CHILD_SUBTYPE = {
		HOLDING: 'HOLDING',
		// This is mainly used for placeholder child portfolios inside a portfolio.
		// We use this on iRetire to detect if the holding is a user portfolio or a normal security/holding
		USER_PORTFOLIO: 'USER_PORTFOLIO'
	};

	public static readonly TYPE = {
		EXCEL: 'xlsx',
		PDF: 'PDF',
		PORTFOLIO: 'PORTFOLIO',
		MODEL_PORTFOLIO: 'MODEL_PORTFOLIO',
		PORTFOLIO_LIKE: 'PORTFOLIO_LIKE',
		PORTFOLIO_POSITION: 'PORTFOLIO_POSITION',
		PORTFOLIO_POSITION_LIKE: 'PORTFOLIO_POSITION_LIKE',
		PREFERENCE: 'PREFERENCE'
	};

	public static readonly USER_DATA_RCS = {
		ALL_DATA: 'bfa-advisor-data',
		PORTFOLIO_IDS: 'bfa-portfolio-ids',
		PORTFOLIO_IDS_NO_ASSET_CLASS: 'bfa-portfolio-noclass-ids'
	};

	public static readonly USER_DATA_PREFS = {
		LOGO: 'logo.details',
		PORTFOLIO_SHARING: 'PORTFOLIO_SHARING'
	};

	// Update https://webster.bfm.com/Wiki/display/ACHO/WebUserData+API+description#WebUserDataAPIdescription-Tool/Appuniversetaxonomy when this list is changed
	// TODO kirti: separate the application reference route and teamsite config path into 2 constants
	public static readonly APPLICATIONS = {
		BFA: 'bfa',
		BFA_TAX: 'bfa.tax',
		BFA_LIBRARY: 'bfa.library',
		BFA_PE: 'bfa.pe',
		BFA_PA: 'bfa.pa',
		BFA_MODELS: 'bfa.models',
		BFA_CMA: 'bfa.cma',
		BFA_DASH: 'bfa.dash',
		BFA_MSTAR: 'bfa.mstar',
		BFA_CAP: 'bfa.cap',
		BFA_ST: 'bfa.st',
		BFA_IQ: 'bfa.iq',
		BFA_PI: 'bfa.pi',
		BPAS: 'bpas',
		BPAS_PAC: 'bpas.pac',
		BPAS_PE: 'bpas.pe',
		NILE: 'nile',
		NILE_PC: 'nile.pc',
		NILE_PE: 'nile.pe',
		NILE_SHARE: 'nile.share',
		BFA_ALADDINU: 'bfa.aladdinu',
		MVAL: 'mval',
		TEAMWORLD: 'mw'
	};
}
